import { type FC, type ReactNode } from "react"
import { type StackProps } from "@chakra-ui/react"

import NavigationTabs from "ui/components/NavigationTabs"
import type { Governor } from "query/graphql"
import useMembersNavigationTabs from "governance/hooks/useMembersNavigationTabs"
import {
  FeatureFlag,
  useOrganization,
} from "organization/providers/OrganizationProvider"

type Props = {
  organizationId: string
  slug: string
  children?: ReactNode
  governor: Governor
  onOpenInfoModal?: () => void
}
const GovernanceMembersNavTabs: FC<Props & StackProps> = ({
  organizationId,
  slug,
  children,
  governor,
  onOpenInfoModal,
  ...stackProps
}) => {
  const { tabs } = useMembersNavigationTabs({ slug, governor, organizationId })

  const { isFeatureFlagOn } = useOrganization()

  const isLegacyLayoutEnabled = isFeatureFlagOn(FeatureFlag.LegacyLayout)

  if (!tabs) {
    return null
  }

  if (isLegacyLayoutEnabled) {
    return null
  }

  return (
    <NavigationTabs
      tabs={tabs}
      {...stackProps}
      onOpenInfoModal={onOpenInfoModal}
    >
      {children}
    </NavigationTabs>
  )
}

export default GovernanceMembersNavTabs
